import DarkColors from './Dark/Colors';
import DarkImages from './Dark/Images';
import LightColors from './Light/Colors';
import LightImages from './Light/Images';

function getThemeColors(themeName) {
  switch (themeName) {
    case 'dark':
      return DarkColors;
    case 'light':
    default:
      return LightColors;
  }
}

function getThemeImages(themeName) {
  switch (themeName) {
    case 'light':
      return LightImages;
    case 'dark':
      return DarkImages;
    default:
      return LightImages;
  }
}

export { getThemeColors, getThemeImages };
